import { Encoder, Decoder } from '@msgpack/msgpack';

import { type Message } from '@canvas/protocol-types';

import {
  decodeMessageKeys,
  encodeMessageKeys,
  type EncodedMessage,
} from '../message-key';

const encoder = new Encoder();
const decoder = new Decoder();

export function encodeMessageV2(message: Message): Uint8Array {
  const keyEncodedMessage = encodeMessageKeys(message);

  return encoder.encode(keyEncodedMessage);
}

export function decodeMessageV2(encodedMessage: Uint8Array): Message {
  const keyEncodedMessage = decoder.decode(encodedMessage) as EncodedMessage;
  return decodeMessageKeys(keyEncodedMessage);
}
